// removed by extract-text-webpack-plugin
module.exports = {"container":"_1ed2e749b6_src-common-_TextInput_container","big":"b5ed3ffe15_src-common-_TextInput_big","label":"_41a026a71c_src-common-_TextInput_label","input":"bbb904eded_src-common-_TextInput_input","small":"_4cb189a584_src-common-_TextInput_small"};


//////////////////
// WEBPACK FOOTER
// ./src/common/TextInput.css
// module id = 923
// module chunks = 0